// extracted by mini-css-extract-plugin
export default {"modal":"T8uBBP","message":"B1mjPt"};